import React, { useState, useEffect, useContext} from 'react';
import pet, { ANIMALS } from '@frontendmasters/pet';
import useDropdown from './useDropdown';
import Results from './Results';
import ThemeContext from './ThemeContext';

const SearchParams = () => {
  const [location, setLocation] = useState('Seattle, WA');
  const [breeds, setBreeds] = useState([]);
  const [animal, AnimalDropdown] = useDropdown('Animal', 'dog', ANIMALS);
  const [breed, BreedDropdown, setBreed] = useDropdown('Breed', '', breeds);
  const [pets, setPets] = useState([]);
  const [theme, setTheme] = useContext(ThemeContext);

  async function requestPets() {
      const { animals } = await pet.animals({
          location,
          breed,
          type: animal
      })

      setPets(animals || []);
    
      console.log(animals);
  }

  useEffect(() => {
      setBreeds([]);
      setBreed('');

      pet.breeds(animal).then(({ breeds: apiBreeds }) => {
          const breedStrings = apiBreeds.map(({ name }) => name);
          setBreeds(breedStrings)
      }, console.error)
  },[animal], setBreeds, setBreed)

  return (
    <div className="search-params">
      <form 
        onSubmit={(e) => {
          e.preventDefault();
          requestPets();
        }}
      >
        <label htmlFor="location">
          location
          <input
            id="location"
            value={location}
            placeholder="Location"
            onChange={(event) => setLocation(event.target.value)}
          />
        </label>
        <AnimalDropdown />
        <BreedDropdown />
        <label htmlFor="theme">
            Theme
            <select
              value={theme}
              onChange={e => setTheme(e.target.value)}
              onBlur={e => setTheme(e.target.value)}
            >
                <option value="peru">Paru</option>
                <option value="#008B8B">Dark Cyan</option>
                <option value="#00008B">Dark Blue</option>
                <option value="#7FFFD4">Aquamarine</option>
                <option value="#00FFFF">Aqua</option>
            </select>
        </label>
        <button style={{ backgroundColor: theme }}>Submit</button>
      </form>
      <Results pets={pets}/>
    </div>
  );
};

export default SearchParams;
